
import Vue from 'vue';
import { RawLocation } from 'vue-router';
import { Component, Prop } from 'vue-property-decorator';
import TagLetterIcon from '@components/shared/icons/TagLetterIcon.vue';
import CircleIcon from '@components/shared/icons/CircleIcon.vue';
import LetterIcon from '@components/shared/icons/LetterIcon.vue';
import ChevronRightIcon from '@components/icons/icon-chevron-right.svg';
import IconPlus  from '@components/icons/icon-plus.svg';

export type LinkType = 'button' | 'row';

export interface SettingsIcon {
  value: string,
  fill: string,
  color: string
}

export interface SettingsItem {
  name: string,
  checked?: boolean,
  to?: RawLocation,
  hint?: string,
  characterIcon?: SettingsIcon,
  tagIcon?: SettingsIcon,
}

@Component({
  name: 'SettingsItemView',
  components: {
    TagLetterIcon,
    CircleIcon,
    LetterIcon,
    ChevronRightIcon,
    IconPlus
  }
})
export default class SettingsItemView extends Vue {
  @Prop({ required: true })
  private item: SettingsItem;

  @Prop({ default: 'row' })
  private linkType: LinkType;

  @Prop({ default: false })
  private disabled: boolean;

  private onRowClick() {
    if (this.isRowLink) {
      this.$router.push(this.item.to);
    }
  }

  private onButtonClick() {
    this.$emit('click')
  }

  get isRowLink() {
    return this.linkType === 'row';
  }
}
